import React, { useState } from 'react';
import './onboarding.css';
import StepIndicator from './StepIndicator';
import CompressionTypeStep from './CompressionTypeStep';
import PricingStep from './PricingStep';
import FinalStep from './FinalStep';

/**
 * OnboardingWizard — 3-step setup flow.
 *
 * Step 1: Choose compression type
 * Step 2: Choose credit pack (or skip / stay on free)
 * Step 3: Confirm & pay (or just activate for free)
 */
function OnboardingWizard({ onComplete }) {
  const [currentStep, setCurrentStep]         = useState(1);
  const [optimizationType, setOptimizationType] = useState(null);
  // selectedPack: null = free tier, or { packageId, name, credits, price } = paid pack
  const [selectedPack, setSelectedPack]       = useState(null);

  const handleCompressionSelect = (type) => {
    setOptimizationType(type);
  };

  /**
   * Called from PricingStep.
   * pack = null → free (no payment needed)
   * pack = { packageId, name, credits, price } → paid
   */
  const handlePricingNext = (pack) => {
    setSelectedPack(pack);
    setCurrentStep(3);
  };

  const handleNext = () => {
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };

  const handleStepClick = (step) => {
    // Allow backward navigation only
    if (step <= currentStep) setCurrentStep(step);
  };

  const handleComplete = () => {
    onComplete({ optimizationTypeId: optimizationType?.id, selectedPack });
  };

  return (
    <div className="onboarding-container">
      <s-section padding="base">
        <s-stack gap="large">
          {/* Welcome Header */}
          <div className="onboarding-step-heading">
            <s-heading>Welcome to Image Optimizer</s-heading>
            <s-paragraph color="subdued">
              Let's get you set up in just a few simple steps. This will only take a minute.
            </s-paragraph>
          </div>

          {/* Step Indicator */}
          <s-box>
            <StepIndicator
              currentStep={currentStep}
              totalSteps={3}
              onStepClick={handleStepClick}
            />
          </s-box>

          {/* Step Content */}
          <s-box>
            {currentStep === 1 && (
              <CompressionTypeStep
                selectedTypeId={optimizationType?.id}
                onSelect={handleCompressionSelect}
                onNext={handleNext}
              />
            )}

            {currentStep === 2 && (
              // onNext receives selectedPack (or null for free)
              <PricingStep onNext={handlePricingNext} />
            )}

            {currentStep === 3 && (
              <FinalStep
                optimizationType={optimizationType}
                selectedPack={selectedPack}
                onComplete={handleComplete}
              />
            )}
          </s-box>
        </s-stack>
      </s-section>
    </div>
  );
}

export default OnboardingWizard;
